import gql from "graphql-tag";

export const CREATE_APPROVAL_BY_USER = gql`
  mutation createApprovalByUser {
    createApprovalByUser
  }
`;
